import { gql } from "@apollo/client";
import { AdvantageFragment } from "./fragments";

export const GET_ADVANTAGE_PROGRAM_FOR_CLIENT = gql`
  query getAdvantagesDetailsByProgramForClient($params: GetAdvantagesDetailsByProgramForClientParams!) {
    results: getAdvantagesDetailsByProgramForClient(params: $params) {
      code
      message
      error
      data {
        ...AdvantageFragment
      }
    }
  }
  ${AdvantageFragment}
`;

export const GET_ACTIVE_PROGRAM_CLIENT = gql`
  query getSubscriptionProgramClient($id: ID!) {
    results: getSubscriptionProgramClient(id: $id) {
      code
      error
      data {
        _id
        title
        iconUrl
        endDate
      }
    }
  }
`;

export const GET_DEMANDES_BY_CLIENT = gql`
  query getAdvantageDemandByClient($id: ID!, $queries: GetAdvantageDemandByClientQueries) {
    results: getAdvantageDemandByClient(id: $id, queries: $queries) {
      code
      error
      data {
        _id
        quantity
        date
        advantage {
          ...AdvantageFragment
        }
      }
      countTotal
    }
  }
  ${AdvantageFragment}
`;

export const ALL_PROGRAMS = gql`
  query getAllPrograms($queries: ProgramsFetchQueries) {
    results: getAllPrograms(queries: $queries) {
      code
      countTotal
      data {
        _id
        iconUrl
        description
        title
      }
    }
  }
`;
